import { convertCo2ScoreString } from '@/data/http/utils/convert-co2-score';
import {
  ExternalInvitation,
  Scope,
  ScopeValues,
  Status,
  StatusValues,
} from '@/domain/external-invitation/entities/external-invitation.entity';
import { getScopeUrlFromScope } from '@/domain/external-invitation/utils/scope-url/get-scope-url';
import { getCategoryFromScope } from '@/domain/external-invitation/utils/scopes/get-category';
import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { PositionMapper } from '../position-geocode/position.mapper';
import { ExternalInvitationDto } from './external-invitation.dto.schema';

export class ExternalInvitationMapper {
  static dtoToEntity(dto: ExternalInvitationDto): ExternalInvitation {
    const scope = validateValueInType<Scope>(dto.scope || '', ScopeValues);
    const category = getCategoryFromScope(scope);
    return {
      id: dto.id,
      projectId: Number(dto.projectId),
      email: dto.email,
      name: dto.name,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      code: dto.code,
      active: dto.active,
      scope: scope,
      scopeUrl: dto.scopeUrl || '',
      expirationDate: dto.expirationDate || '',
      eventPosition: dto.eventPosition
        ? PositionMapper.dtoToEntity(dto.eventPosition)
        : undefined,
      title: dto.title || '',
      completion: Number(dto.completion),
      co2ImpactScore: convertCo2ScoreString(dto.score || ''),
      status: validateValueInType<Status>(dto.status || '', StatusValues),
      isValidated: dto.isValidated,
      category: category,
      createdAt: dto.createdAt,
    };
  }

  static buildInviteInputParams(
    name: string,
    email: string,
    limitDate: string,
    eventPosition: PositionGeocode | undefined,
    title: string,
    sector: Sector,
    scope: Scope,
    projectId: number,
    organisationId: number,
  ) {
    return {
      email: email,
      name: name,
      expirationDate: limitDate ? new Date(limitDate).toISOString() : null,
      eventPosition: eventPosition
        ? PositionMapper.entityToDto(eventPosition)
        : undefined,
      title: title,
      projectId: projectId,
      organisationId: organisationId,
      sector: sector,
      scope: scope,
      scopeUrl: getScopeUrlFromScope(scope),
    };
  }
}
